import VeeValidate, {Validator} from 'vee-validate'
import CommonUtil from '../utils/common'

export default function (SkyFoxVue) {

  const overrideValidateLocaleJa = {
    messages: {
      after: (field, [target]) => `${field}は${target}の後に入力してください`,
      alpha_dash: (field) => `${field}は英数字とハイフン、アンダースコアのみ使用できます`,
      alpha_num: (field) => `${field}は英数字のみ使用できます`,
      alpha_spaces: (field) => `${field}はアルファベットと空白のみ使用できます`,
      alpha: (field) => `${field}はアルファベットのみ使用できます`,
      before: (field, [target]) => `${field}は${target}よりも前に入力してください`,
      between: (field, [min, max]) => `${field}は${min}から${max}の範囲で入力してください`,
      confirmed: (field) => `${field}が一致しません`,
      credit_card: (field) => `${field}を正しく入力してください`,
      date_between: (field, [min, max]) => `${field}は${min}から${max}の範囲で入力してください`,
      date_format: (field, [format]) => `${field}は${format}形式で入力してください`,
      decimal: (field, [decimals] = ['*']) => {
        if (decimals === '*') {
          return `${field}は実数で入力してください`
        } else {
          return `${field}は小数点以下${decimals === '*'
            ? ''
            : decimals}桁までの実数で入力してください`
        }
      },
      digits: (field, [length]) => `${field}は${length}桁の数字で入力してください`,
      dimensions: (
        field,
        [width, height]) => `${field}は幅${width}px、高さ${height}px以内で入力してください`,
      email: (field) => `${field}が有効なメールアドレスではありません`,
      ext: (field) => `${field}が有効なファイル形式ではありません`,
      image: (field) => `${field}が有効な画像形式ではありません`,
      in: (field) => `${field}が有効な値ではありません`,
      integer: (field) => `${field}は数字を入力してください`,
      ip: (field) => `${field}が有効な値ではありません`,
      length: (field, [length, max]) => {
        if (max) {
          return `${field}は${length}〜${max}文字で入力してください`
        }
        return `${field}は${length}文字で入力してください`
      },
      max: (field, [length]) => `${field}は${length}文字以内で入力してください`,
      max_value: (field, [max]) => `${field}は${max}以下で入力してください`,
      mimes: (field) => `${field}は有効なファイル形式ではありません`,
      min: (field, [length]) => `${field}は${length}文字以上で入力してください`,
      min_value: (field, [min]) => `${field}は${min}以上で入力してください`,
      not_in: (field) => `${field}が不正な値です`,
      numeric: (field) => `${field}は数字のみ使用できます`,
      regex: (field) => `${field}が正しくありません`,
      required: (field) => `${field}は必須です`,
      url: (field) => `${field}が正しいURLではありません`,
      is_not: (field) => `${field}には別の値を入力してください`,
      room_pattern: (field) => `${field}は以下のフォーマットで入力してください
                              1文字目：1以上の数字
                              2文字目以降：数字、もしくは「S」「L」「D」「K」「R」のいずれか`,
      more_than: (
        field,
        [otherValue, otherField]) => `${field}は${otherField}の値よりも大きな値を入力してください`,
      less_than: (
        field,
        [otherValue, otherField]) => `${field}は${otherField}の値よりも小さな値を入力してください`
    }
  }

  Validator.extend('alpha_num_symbol', {
    getMessage: (field) => `${field}は英数字と記号のみ使用できます`,
    validate (val) {
      return /^[a-zA-Z0-9!-/:-@¥[-`{-~]+$/.test(val)
    }
  })

  Validator.extend('more_than', {
    getMessage: (
      field,
      [otherValue, otherField]) => `${field}は${otherField}の値よりも大きな値を入力してください`,
    validate (val, [otherValue, otherField]) {
      return (CommonUtil.isEmpty(otherValue) || CommonUtil.isEmpty(val) || val >
      otherValue)
    }
  }, {
    hasTarget: true
  })

  Validator.extend('less_than', {
    getMessage: (
      field,
      [otherValue, otherField]) => `${field}は${otherField}の値よりも小さな値を入力してください`,
    validate (val, [otherValue, otherField]) {
      return (CommonUtil.isEmpty(otherValue) || CommonUtil.isEmpty(val) || val <
      otherValue)
    }
  }, {
    hasTarget: true
  })

  Validator.extend('room_pattern', {
    getMessage: (field) => `${field}は以下のフォーマットで入力してください
                          1文字目：半角数字で1以上
                          2文字目以降：半角数字、もしくは「S」「L」「D」「K」「R」のいずれか`,
    validate (val) {
      return /^[1-9][0-9SLDKR]+$/.test(val)
    }
  })

  Validator.localize('ja', overrideValidateLocaleJa)
  SkyFoxVue.use(VeeValidate, {locale: 'ja'})

  return SkyFoxVue

}



// WEBPACK FOOTER //
// ./src/extentions/validator.js